import Vue from 'vue';
import ProgressSpinner from 'primevue/progressspinner';

Vue.component('ProgressSpinner', ProgressSpinner);
